export default class TypingTester {
    constructor(time) {
        this.speed = time
        this.lastKeystrokeTime = 0
    }

    record(onTypingEnd) {
        this.lastKeystrokeTime = new Date().getTime()

        setTimeout(() => {
            if (new Date().getTime() - this.lastKeystrokeTime >= this.speed) {
                if (onTypingEnd) {
                    onTypingEnd()
                }
            }
        }, this.speed)
    }
}
